'use strict'

import $ from 'jquery'

export function layouts() {
	$('#header-search-box-input').val('').trigger('change')

	$('#btn_search').on('click', function() {
		$('#form_search').show()
		$('#btn_search').hide()
	})

	$('#btn_close').on('click', function() {
		$('#form_search').hide()
		$('#btn_search').show()
	})

	$('.section-click-collapse').click(function(){
		$('#book-tree').find('.section-chapter').toggle();
		if ($('.toggle-fa').hasClass('fa-caret-down')) {
			$('.toggle-fa').removeClass('fa-caret-down').addClass('fa-caret-up');
		}else{
			$('.toggle-fa').removeClass('fa-caret-up').addClass('fa-caret-down');
		}
	});

}
